import React, { useState } from 'react';
import { Switch } from '@components/atoms';

export interface SettingsToggleProps {
  label?: string | React.JSX.Element;
  currentValue?: boolean;
  apiUrl?: string;
  onChangeValue?: (value: boolean) => void;
}
const SettingsToggle = ({ label, currentValue, onChangeValue }: SettingsToggleProps) => {
  return (
    <>
      {label}
      <Switch defaultValue={currentValue} onChangeValue={onChangeValue} />
    </>
  );
};

export default SettingsToggle;
